import {format, subMonths} from 'date-fns';
import {
	GetReferralsParams,
	ReferralStatusEnum,
	ReferralTypeEnum,
} from 'domain/usecases/private/my-referrals-flow/get-referrals';
import {MyReferralsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';

const {all, exam, consult, surgery} = translations['pt-br'].commons;
const {success, pending, scheduled, finished, rejected, underAnalysis} =
	translations['pt-br'].privateFlow.myReferrals.status;

export const useReferralsList = () => {
	const DefaultParams: GetReferralsParams = {
		dtInicio: format(subMonths(new Date(), 3), 'yyyy-MM-dd'),
		dtFim: format(new Date(), 'yyyy-MM-dd'),
	};
	const Filters = {
		types: [
			{
				label: all,
				category: 'all',
				dataTagId:
					MyReferralsTaggingEnum.CLICK_FILTRO_TIPO_PROCEDIMENTO_TODOS_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: exam,
				category: ReferralTypeEnum.EXAM,
				dataTagId:
					MyReferralsTaggingEnum.CLICK_FILTRO_TIPO_PROCEDIMENTO_EXAME_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: surgery,
				category: ReferralTypeEnum.SURGERY,
				dataTagId:
					MyReferralsTaggingEnum.CLICK_FILTRO_TIPO_PROCEDIMENTO_CIRURGIA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: consult,
				category: ReferralTypeEnum.APPOINTMENT,
				dataTagId:
					MyReferralsTaggingEnum.CLICK_FILTRO_TIPO_PROCEDIMENTO_CONSULTA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS,
			},
		],
		status: [
			{
				label: all,
				category: 'all',
				dataTagId:
					MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_TODOS_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: success,
				category: ReferralStatusEnum.SUCCESS,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_LIBERADO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: pending,
				category: ReferralStatusEnum.PENDING,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_PENDENTE_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: scheduled,
				category: ReferralStatusEnum.SCHEDULED,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_AGENDADO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: finished,
				category: ReferralStatusEnum.FINISHED,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_CONCLUIDO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: rejected,
				category: ReferralStatusEnum.REJECTED,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_INDEFERIDO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: underAnalysis,
				category: ReferralStatusEnum.UNDER_ANALYSIS,
				dataTagId:
					MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_EM_ANALISE_MEUS_ENCAMINHAMENTOS,
			},
		],
	};
	return {
		DefaultParams,
		Filters,
	};
};
